
import React from "react";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";
import { assetUrl } from "@/config/assets";

const TransformMorningsSection = () => {
  return (
    <section
      className="py-16 md:py-24 relative bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('${assetUrl(
          "homepage-media/Whimsical-North-Pole-Sunrise.webp",
        )}')`,
      }}
    >
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
          Transform Your December Mornings
        </h2>
        <p className="text-xl text-white mb-8 max-w-2xl mx-auto">
          Start with three free personalized PDF deliveries per email address on Elf Letter Bot. When you want unlimited letters, premium templates, and saved family details, The Magic Letter Box Family membership is $15/year.
        </p>
        <MagicLetterBoxLink
          source="transform-mornings"
          campaign="family-membership"
          className="inline-block rounded-xl bg-elfRed-ink px-8 py-4 text-lg font-semibold text-white shadow-md transition-colors duration-300 hover:bg-[#892638] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          Explore The Magic Letter Box
        </MagicLetterBoxLink>
      </div>
    </section>
  );
};

export default TransformMorningsSection;
